import { rodnecislo } from "rodnecislo";
import { parsePhoneNumber } from "awesome-phonenumber";
import moment from "moment";

export default class baseValidators {
    static identificationNumber(value) {
        return rodnecislo(value).isValid();
    }

    static zipCode(value) {
        const zipCodeWithoutSpace = /^(\d{5})?$/;
        var zipCodeWithSpace = /^(\d{3} ?\d{2})?$/;

        return zipCodeWithoutSpace.test(value) || zipCodeWithSpace.test(value);
    }

    static email(email) {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    static ic(value) {
        //Popis validace https://phpfashion.com/jak-overit-platne-ic-a-rodne-cislo
        if (isNaN(value)) return false;
        try {
            var a = 0;
            if (value.length == 0) return true;
            if (value.length != 8) throw 1;
            var b = value.split("");
            var c = 0;
            for (var i = 0; i < 7; i++) a += parseInt(b[i]) * (8 - i);
            a = a % 11;
            c = 11 - a;
            if (a == 1) c = 0;
            if (a == 0) c = 1;
            if (a == 10) c = 1;
            if (parseInt(b[7]) != c) throw 1;
        } catch (e) {
            return false;
        }
        return true;
    }

    static phone(value) {
        if (!value || typeof value !== 'string') {
            return { valid: false, phoneNumber: null };
        }
        let phone = parsePhoneNumber(value);
        return { valid: phone.valid, phoneNumber: phone };
    }

    static date(value) {
        return value && value.match(/^(\d{2})\.(\d{2})\.(\d{4})$/) && moment(value, "DD.MM.YYYY", true).isValid();
    }

    static dateBeforeToday(value, excludeToday) {
        var now = new Date();
        const dateParts = value.split(".");
        if (excludeToday) dateUTC.setDate(dateUTC.getDate() - 1);
        const dateUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        const inputDate = new Date(dateParts[2], +dateParts[1] - 1, dateParts[0]);

        return inputDate <= dateUTC;
    }

    static dateAfterToday(value, excludeToday) {
        var now = new Date();
        const dateUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        if (excludeToday) dateUTC.setDate(dateUTC.getDate() + 1);
        const dateParts = value.split(".");
        const inputDate = new Date(dateParts[2], +dateParts[1] - 1, dateParts[0]);

        return inputDate >= dateUTC;
    }

    static validateOPR(value) {
        return value && value.match(/^(\d{9})$/);
    }

    static validateRP(value) {
        return value && value.match(/^[A E I O U Y][A-Z](\d{6})$/);
    }

    static originatorHB(value) {
        return !!value && value.match(/^[A-Z,0-9]{8}$/);
    }

    static rateDiscountHB(value, numFrom, numTo) {
        return !isNaN(value) && value >= numFrom && value <= numTo;
    }

    static requiredAppl(value, application, applicantTypes) {
        let requiredTypes = applicantTypes.filter(appl => appl.required);
        let requiredTypesNotSelected = [];

        for (let i = 0; i < requiredTypes.length; i++) {
            let typeId = requiredTypes[i].value;
            let applicantOfType = application.households.flatMap(h => h.applicants).filter(appl => appl.applicantType === typeId);

            if (applicantOfType.length === 0) {
                requiredTypesNotSelected.push(requiredTypes[i]);
            }
        }

        return requiredTypesNotSelected;
    }

    static onlyOnceAppl(value, application, curApplicantType) {
        if (curApplicantType == null || !curApplicantType.onlyOnce) return true;
        let applicantOfSameType = application.households
            .flatMap(h => h.applicants)
            .filter(appl => appl.applicantType === curApplicantType.value);

        return !(applicantOfSameType.length > 1);
    }
}
